import React, { Component } from 'react';
import {
    Container,
    Typography,
    Box,
    withStyles
} from '@material-ui/core';
import { withRouter } from 'react-router-dom';
import BreadcrumbLayout from "../../shared/components/common/breadcrumbLayout";
import EquipamentDetailsHistoryContainer
    from "../../shared/components/equipamentDetails/equipamentDetailsHistoryContainer";
import ImageModal from "../../shared/components/common/imageModal";
import EquipamentDetailsImagesContainer
    from "../../shared/components/equipamentDetails/equipamentDetailsImagesContainer";
import EquipamentDetailsInfoContainer from "../../shared/components/equipamentDetails/equipamentDetailsInfoContainer";

const styles = (theme) => ({
    container: {
        backgroundColor: "#FFFFFF",
        color: "#000000"
    },
    content: {
        margin: "40px auto",
        padding: "20px",
        maxWidth: "800px",
        backgroundColor: "#FFFFFF",
    },
    title: {
        fontWeight: "400",
        fontSize: "calc(1.3rem + .6vw)",
        marginBottom: "0.5rem",
        color: "#222222",
    },
    sectionTitle: {
        fontWeight: "500",
        marginTop: "2rem",
        marginBottom: "0.5rem",
        color: "#222222",
        borderBottom: "1px solid #CCCCCC",
        paddingBottom: "5px",
    },
});

class AdminEquipamentDetailsPage extends Component {
    constructor(props) {
        super(props);
        this.state = {
            equipment: null,
            loading: true,
            error: null,
            selectedImage: null,
            modalOpen: false,
        };
    }

    componentDidMount() {
        this.fetchEquipmentData();
    }

    fetchEquipmentData = () => {
        const id = this.props.match.params.id || sessionStorage.getItem("CORE_EquipamentoSelecionado") || 1;

        if (!id) {
            const { currentLanguage } = this.props;
            this.setState({ error: currentLanguage.bepiService.admin.admin_equip_details_error_id_not_found, loading: false });
            return;
        }

        setTimeout(() => {
            const mockData = {
                equipamento: {
                    id: 1,
                    nome: "Talabarte",
                    marca: "Vicsa",
                    modelo: "Vic-Trip X355",
                    ca: "12345",
                    serie: "SN123456",
                    ultima_revisao: "2024-05-28",
                    proxima_revisao: "2024-11-28",
                },
                fotos: [
                    { nome_arquivo: "https://btequipamentos.agilecdn.com.br/280049_1.jpg", nome: "Foto frontal" },
                    { nome_arquivo: "https://www.vicsa.com.br/wp-content/uploads/VIC26806.jpg", nome: "Foto lateral" },
                ],
                laudos: [
                    {
                        created_at: "2024-05-28T18:30:00",
                        nome_arquivo: "laudo1.pdf",
                        nome: "Manutenção completa",
                        descricao: "Inspeção e troca de gancho"
                    },
                    {
                        created_at: "2024-05-12T18:30:00",
                        nome_arquivo: "laudo2.pdf",
                        nome: "Inspeção",
                        descricao: "Inspeção de rotina"
                    }
                ]
            };

            this.setState({
                equipment: mockData,
                loading: false,
                error: null
            });
        }, 1000);
    }

    handleImageClick = (imageUrl) => {
        this.setState({ selectedImage: imageUrl, modalOpen: true });
    }

    handleCloseModal = () => {
        this.setState({ modalOpen: false, selectedImage: null });
    }

    getBreadcrumbItems = () => {
        const { currentLanguage } = this.props;
        return [
            { label: currentLanguage.bepiService.shared.shared_breadcrumb_home, path: '/bepi/admin' },
            { label: currentLanguage.bepiService.shared.shared_breadcrumb_equipments, path: '/bepi/admin/equipaments' },
            { label: currentLanguage.bepiService.shared.shared_breadcrumb_details },
        ];
    }

    renderLoading = () => {
        const { classes, currentLanguage } = this.props;
        return (
            <BreadcrumbLayout
                title={currentLanguage.bepiService.shared.shared_breadcrumb_details}
                breadcrumbItems={this.getBreadcrumbItems()}
                currentLanguage={currentLanguage}
                showBackButton
            >
                <Box className={classes.container}>
                    <Container className={classes.content}>
                        <Typography>{currentLanguage.bepiService.admin.admin_equip_details_loading_text}</Typography>
                    </Container>
                </Box>
            </BreadcrumbLayout>
        );
    }

    renderError = (error) => {
        const { classes, currentLanguage } = this.props;
        return (
            <BreadcrumbLayout
                title={currentLanguage.bepiService.shared.shared_breadcrumb_details}
                breadcrumbItems={this.getBreadcrumbItems()}
                currentLanguage={currentLanguage}
                showBackButton
            >
                <Box className={classes.container}>
                    <Container className={classes.content}>
                        <Typography color="error">{error}</Typography>
                    </Container>
                </Box>
            </BreadcrumbLayout>
        );
    }

    renderNotFound = () => {
        const { classes, currentLanguage } = this.props;
        return (
            <BreadcrumbLayout
                title={currentLanguage.bepiService.shared.shared_breadcrumb_details}
                breadcrumbItems={this.getBreadcrumbItems()}
                currentLanguage={currentLanguage}
                showBackButton
            >
                <Box className={classes.container}>
                    <Container className={classes.content}>
                        <Typography>{currentLanguage.bepiService.admin.admin_equip_details_error_not_found}</Typography>
                    </Container>
                </Box>
            </BreadcrumbLayout>
        )
    };

    render() {
        const { classes } = this.props;
        const { equipment, loading, error, selectedImage, modalOpen } = this.state;
        const { currentLanguage } = this.props

        if (loading) return this.renderLoading();
        if (error) return this.renderError(error);
        if (!equipment) return this.renderNotFound();

        const { equipamento, fotos, laudos } = equipment;

        return (
            <BreadcrumbLayout
                title={currentLanguage.bepiService.shared.shared_breadcrumb_details}
                breadcrumbItems={this.getBreadcrumbItems()}
                currentLanguage={currentLanguage}
                showBackButton
            >
                <Box className={classes.container}>
                    <Container className={classes.content}>
                        <Typography className={classes.title}>
                            {currentLanguage.bepiService.admin.admin_equip_details_title_item_data}
                        </Typography>
                        <EquipamentDetailsInfoContainer equipment={equipamento} currentLanguage={currentLanguage} />

                        <Typography variant="h5" className={classes.sectionTitle}>
                            {currentLanguage.bepiService.admin.admin_equip_details_title_latest_photos}
                        </Typography>
                        <EquipamentDetailsImagesContainer
                            photos={fotos}
                            onPhotoClick={this.handleImageClick}
                            currentLanguage={currentLanguage}
                        />

                        <Typography variant="h5" className={classes.sectionTitle}>
                            {currentLanguage.bepiService.admin.admin_equip_details_title_revision_history}
                        </Typography>
                        <EquipamentDetailsHistoryContainer history={laudos} currentLanguage={currentLanguage} />

                        <ImageModal
                            isOpen={modalOpen}
                            imageUrl={selectedImage}
                            onClose={this.handleCloseModal}
                            currentLanguage={currentLanguage}
                        />
                    </Container>
                </Box>
            </BreadcrumbLayout>
        );
    }
}

export default withRouter(withStyles(styles)(AdminEquipamentDetailsPage));
